// AI Generated File
import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { PipeService } from '@client/app/filters/pipe-transformation.service';
import { page_fix_settings } from '@monsido/core/constants/general.constant';

@Component({
    selector: 'page-fix-summary-diagnostics',
    standalone: false,
    template: `
        <div class="page-fix-summary-diagnostics">
            <div class="row justify-content-sm-center">
                <div class="col-48 col-sm-24 d-flex flex-column align-items-center">
                    <p class="text-bold">
                        <span translate>Overall PageCorrects</span>
                        <span class="fas fa-info-circle" [ngbTooltip]="'Coming soon' | translate" [triggers]="'focus hover'" aria-hidden="true"></span>
                    </p>
                    <mon-chart-doughnut [data]="totalPageFixData"
                                        [colors]="colors"
                                        [options]="totalPageFixOptions"
                                        [labels]="labels">
                    </mon-chart-doughnut>
                </div>
                <div class="col-48 col-sm-24 d-flex flex-column align-items-center">
                    <p class="text-bold">
                        <span translate>Spelling Errors used</span>
                        <span class="fas fa-info-circle" [ngbTooltip]="'Coming soon' | translate" [triggers]="'focus hover'" aria-hidden="true"></span>
                    </p>
                    <mon-chart-doughnut [data]="spellingFixData"
                                        [colors]="colors"
                                        [options]="spellingFixOptions"
                                        [labels]="labels">
                    </mon-chart-doughnut>
                </div>
            </div>
            <div class="row mt-6">
                <div class="col-48 d-flex align-items-center mt-3">
                    <icon-circle [icon]="'fas fa-info'"></icon-circle>
                    @let totalFixes = totalPageFixes | monNumber;
                    @let pageFixLimit = 'page_fix_total_limit' | pageFixSettings | monNumber;
                    <span class="ml-4" translate [translate-args]="{totalFixes, pageFixLimit}">
                        You currently have <strong>[[totalFixes]]</strong> corrections, we recommend limiting your number of corrections to <strong>[[pageFixLimit]]</strong> to ensure optimum page performance, however, this is at your own discretion.
                    </span>
                </div>
                <div class="col-48 d-flex align-items-center mt-3">
                    <icon-circle [icon]="'fas fa-language'"></icon-circle>
                    @let computedSpellingFixes = spellingFixes | monNumber;
                    @let spellingLimit = 'spelling_limit' | pageFixSettings | monNumber;
                    <span class="ml-4" translate [translate-args]="{spellingFixes: computedSpellingFixes, spellingLimit}">
                        You currently have <strong>[[spellingFixes]]</strong> Spelling Errors corrections, we recommend that you keep this number to below <strong>[[spellingLimit]]</strong> to ensure the page displays without issue.
                    </span>
                </div>
            </div>
        </div>
    `,
})
export class PageFixSummaryDiagnosticsComponent implements OnInit {
    @Input() totalPageFixes: any;
    @Input() spellingFixes: any;

    colors: any;
    labels: any;
    totalPageFixData: any;
    totalPageFixOptions: any;
    spellingFixData: any;
    spellingFixOptions: any;

    constructor (
        private pipeService: PipeService,
        private translateService: TranslateService,
    ) {}

    ngOnInit (): void {
        this.activate();
    }

    private activate (): void {
        this.colors = ['#526CFC', '#dcdcdc'];
        this.labels = [this.translateService.getString('PageFixes'), this.translateService.getString('PageFixes Left')];
        this.setupSpellingFixesGraph();
        this.setupTotalPageFixesGraph();
    }

    private setupTotalPageFixesGraph (): void {
        this.totalPageFixData = [
            this.totalPageFixes,
            this.getProperValue(page_fix_settings.page_fix_total_limit - this.totalPageFixes),
        ];
        this.totalPageFixOptions = this.getOptions(this.totalPageFixes, page_fix_settings.page_fix_total_limit);
    }

    private setupSpellingFixesGraph (): void {
        this.spellingFixData = [
            this.spellingFixes,
            this.getProperValue(page_fix_settings.spelling_limit - this.spellingFixes),
        ];
        this.spellingFixOptions = this.getOptions(this.spellingFixes, page_fix_settings.spelling_limit);
    }

    private getOptions (fixes: any, limit: any): any {
        return {
            centerText: {
                percentageLabel: this.pipeService.get('monNumber')(fixes / limit || 0, '0.[00] %'),
                totalLabel: fixes + '/' + limit,
                totalFontSize: 150,
            },
            cutoutPercentage: 80,
        };
    }

    private getProperValue (value: any, minValue?: any): any {
        minValue = minValue || 0;
        if (value < minValue) {
            return 0;
        } else {
            return value;
        }
    }
}
